import { Pipe, PipeTransform } from '@angular/core';
import {
  RemoteUserAdditionalInfoStateModel,
  RemoteUserInfoStateModel,
  RemoteUsersInfoState
} from '@app/state/remote-users.state';
import {Store} from '@ngxs/store';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';

@Pipe({
  name: 'userById'
})
export class UserByIdPipe implements PipeTransform {
  public constructor(private store: Store) {}

  public transform(userId: number): LocalUser | RemoteUserAdditionalInfoStateModel | undefined {
    const localUser: LocalUser = this.store.selectSnapshot(LocalUserState);
    if (localUser.id === userId) {
      return localUser;
    }

    const remoteUserInfoStateModel: RemoteUserInfoStateModel = this.store.selectSnapshot(RemoteUsersInfoState);
    return remoteUserInfoStateModel.usersInfoById[userId];
  }
}
